import { JuloUpdateEntry } from "./types"

export const welcomeEntry: JuloUpdateEntry = {
  slug: "2026-05-06-welcome",
  date: "2026-05-06",
  title: "Välkommen till uppdateringar från Julo",
  description:
    "Här samlar vi nyheter, förbättringar och fixar i Julo. Varje gång vi gör en ändring som påverkar er som mekaniker postar vi en uppdatering här – så att ni enkelt kan följa med i vad som är nytt.",
}
